// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v7_n","left":"styles_left__3KUeX"};